import { toast } from 'sonner';

import { emailClipboardContent, videos } from './constants';
import { handleDownloadClientMaterialsEml } from './helpers';
import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { useUserContext } from '@/Contexts/User';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';

export function EmailContent() {
  const { user } = useUserContext();
  const { fetchConfigGET } = useGetFetchConfig();

  return (
    <>
      <DialogHeader>
        <DialogTitle>Email Template</DialogTitle>
      </DialogHeader>

      <div className="rounded-lg border bg-gray-50 p-4">
        <div className="space-y-3 text-sm text-gray-700">
          <p>Dear [Client],</p>
          <p>
            We have onboarded a platform called{' '}
            <a
              href="https://wexler.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              wexler.ai
            </a>{' '}
            to assist with our litigation workflows. It reads through documents and extracts the key facts, creates
            chronologies and allows you to ask and answer questions. The security details are found at{' '}
            <a
              href="https://trust.wexler.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              trust.wexler.ai
            </a>
            , and I have attached two documents explaining the product in more detail.
          </p>
          <p>Videos of the platform:</p>
          <ul className="list-inside list-disc space-y-1">
            {videos.map((video) => (
              <li key={video.title}>
                <a href={video.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                  {video.title}
                </a>
              </li>
            ))}
          </ul>

          <p>Let me know if you have any further questions.</p>
          <p>Kind regards,</p>
        </div>
      </div>

      <div className="mt-6 flex justify-end gap-2">
        <Button onClick={() => handleDownloadClientMaterialsEml(user?.email ?? '', fetchConfigGET)}>
          <Icon className="lucide--download" />
          Download with Attachments
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            navigator.clipboard.writeText(emailClipboardContent);
            toast.success('Email template copied to clipboard');
            trackCustomEvent(TrackingEventsV2.ClientMaterialsCopyEmailTemplate);
          }}
        >
          <Icon className="lucide--copy" />
          Copy to Clipboard
        </Button>
      </div>
    </>
  );
}
